import { useEffect } from 'react'

// import $api from '../API'
import { useAppDispatch } from '../store'
import { setServerVersion } from '../store/modules/app'

export function CommitSetter (): null {
  let dispatch = useAppDispatch()

  useEffect(() => {
    let originalFetch = window.fetch

    window.fetch = async (...args) => {
      let response = await originalFetch(...args)

      let ref = response.headers.get('x-build-commit-ref')?.trim() ?? undefined
      let date = response.headers.get('x-build-commit-date')?.trim() ?? undefined

      if (ref ?? date) {
        dispatch(setServerVersion({ ref, date }))
      }
      return response
    }

    return () => {
      window.fetch = originalFetch
    }
  }, [ dispatch ])

  return null
}
